import type { ReactNode } from 'react'

export const LEGITSCRIPT_VERIFY_URL =
  'https://www.legitscript.com/websites/?checker_keywords=nextclinic.com.au'
export const LEGITSCRIPT_SEAL_URL =
  'https://static.legitscript.com/seals/43240605.png'

type LegitScriptSealLinkProps = {
  children?: ReactNode
  className?: string
  imageClassName?: string
  imageWidth?: number
  imageHeight?: number
}

export function LegitScriptSealLink({
  children,
  className,
  imageClassName,
  imageWidth = 132,
  imageHeight = 145,
}: LegitScriptSealLinkProps) {
  return (
    <a
      href={LEGITSCRIPT_VERIFY_URL}
      target="_blank"
      rel="noreferrer"
      title="Verify LegitScript approval for nextclinic.com.au"
      className={className}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={LEGITSCRIPT_SEAL_URL}
        alt="LegitScript certified"
        width={imageWidth}
        height={imageHeight}
        className={imageClassName}
      />
      {children}
    </a>
  )
}
